/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useEffect, useState } from 'react'
import { Link } from 'react-router-dom'
import { Plants } from '../../../@types/plants'
import { getAlarmStatus } from '../../../services/alarm'
import { getMark } from '../../../services/markService'
import { getplantsAllSimplePagination } from '../../../services/plantsService'
import { getTagsAll } from '../../../services/tagsService'
import { searchSubstitut } from '../../../utils/search'
import { Loading } from '../../components/Loadings/loading'
import { useToast } from '../../components/Toats'
import useSize from '../../../hooks/useSize'
import { useQuery } from 'react-query'
import { AlarmStatus } from '../../../@types/alarmStatus'

import styles from './tablePlants.module.css';
import { SelectGlobal } from '../../components/SelectGlobal'
import { PaginationTablePlants } from './components/Pagination'
import { TablePlantsSearchComputer } from './components/TableV1'
import { TablePlantsSearchPhone } from './components/TableV2'
import { SearchInputV3 } from '../../components/SearchInputV3'
import { useAuth } from '../../../modules/auth'
import { KTSVG } from '../../../../_metronic/helpers'
import { ModalCreatePlantCompositeTable } from './components/ModalCreatePlantCompositeTable'
import { PlantStatusTabs } from './components/PlantStatusTabs'
import listLayoutStyles from '../../components/ListTableLayout/listTableLayout.module.css'
import toolbarStyles from '../../../components/OrderServiceChecklist/OrderServiceToolbar/orderServiceToolbar.module.css'

type Props = {
  className: string;
  isExpanded: boolean;
  setIsExpanded: (isExpanded: boolean) => void;
}

type Paginations = {
  page: number,
  limit: number,
  total: number,
  qtdPages: number
}

type SetPaginations = {
  start: number;
  end: number;
}

type PerformanceFilter = {
  period: string;
  direction: string;
  value: string;
}

const DEFAULT_PERFORMANCE_FILTER: PerformanceFilter = {
  period: '',
  direction: '',
  value: '100',
}

const TablesPlants: React.FC<Props> = ({className, isExpanded, setIsExpanded}) => {
    const { toggleToast } = useToast();
    const [filterAlarms, setFilterAlarms] = useState<number>(-1);
    const [filterMarks, setFilterMarks] = useState<string>("");
    const [filterPlano, setFilterPlano] = useState<string>("");
    const [filterTag, setFilterTag] = useState<string>("");
    const [filterOrderByName, setFilterOrderByName] = useState<string>("");
    const [filterOfflineMoreThan3h, setFilterOfflineMoreThan3h] = useState<string>("");
    const [filterPerformance, setFilterPerformance] = useState<PerformanceFilter>(DEFAULT_PERFORMANCE_FILTER);
    const [filterName, setFilterName] = useState<string>("");
    const [mySearch, setMySearch] = useState<Plants[]>([]);
    const [control, setControl] = useState<boolean>(false);
    const {height, width} = useSize();
    const [showCreateAppModalPlantComposite, setShowCreateAppModalPlantComposite] = useState<boolean>(false);
    const user = useAuth();

    const [pagination, setPagination] = useState<Paginations>({
      page: 1,
      limit: user 
        && user.currentUser 
        && user.currentUser.role 
        && (user.currentUser.role.slug === "EMPRESA" 
          || user.currentUser.role.slug === "FILIAL")
        ? 50 
        : 15,
      total: 0,
      qtdPages: 1
    });

    const [qtd, setQtd] = useState<SetPaginations>({
      start: 0,
      end: user 
      && user.currentUser 
      && user.currentUser.role 
      && (user.currentUser.role.slug === "EMPRESA" 
        || user.currentUser.role.slug === "FILIAL")
      ? 50 
      : 15,
    });

    const { data: plants, isLoading: loadingMyPlants, refetch: refreshPlants } = useQuery<Plants[] | []>(
      ["getPlants", filterAlarms, filterMarks, filterPlano, filterTag, filterOrderByName, filterOfflineMoreThan3h, filterPerformance, filterName, pagination.page],
      async () => {
        const performanceQuery = filterPerformance.period && filterPerformance.direction
          ? `&performancePeriod=${filterPerformance.period}&performanceDirection=${filterPerformance.direction}&performanceValue=${filterPerformance.value || '100'}`
          : "";

        const url = `?status=${filterAlarms !== -1 && filterAlarms !== -2 ? filterAlarms : ""}&mark=${filterMarks}&limit=${pagination.limit}&page=${pagination.page}&alert=${filterAlarms === -2 ? true : false}${filterName !== "" ? `&name=${filterName}` : ""}${filterPlano !== "" ? `&plano=${filterPlano}` : ""}${filterTag !== "" ? `&tag=${filterTag}` : ""}${filterOrderByName === "true" ? "&orderByName=true" : ""}${filterOfflineMoreThan3h === "true" ? "&offlineMoreThan3h=true" : ""}${performanceQuery}&activeMark=true&activePrognosis=true&activeMarkChildPlants=true&activeTags=true`
        const myPlants = await getplantsAllSimplePagination(url)
        setPagination({...pagination, qtdPages: myPlants.lastPage, total: myPlants.total})

        const search_plants = mySearch && mySearch.length > 0 ? 
          searchSubstitut(myPlants.data, mySearch)
        : []
        setMySearch(search_plants)

        return myPlants.data
      },
      {
        onError: (error) => {
          console.log(error);
          toggleToast("Erro ao buscar as usinas. ", "error");
        },
      }
    )

    const { 
      data: alarmStatus = {
        attention: 0,
        alarmNum: 0,
        normalNum: 0,
        offlineNum: 0,
        total: 0,
        info: 0,
        alertCount: 0
      }, 
      isLoading: loadingSomeAlarmStatus 
    } = useQuery<AlarmStatus>(
      ["getSomeAlarmStatus"],
      async () => {
        const alarmStatusResult = await getAlarmStatus()
        return alarmStatusResult
      },
      {
        onError: (error) => {
          console.log(error);
          toggleToast("Erro ao buscar os status das usinas. ", "error")
        },
      }
    )

    const { data: marks = [], isLoading: loadingMyMarks } = useQuery<any>(
      ["getMarksAll"],
      async () => {
        const marks = await getMark(true)
        return marks
      },
      {
        onError: (error) => {
          console.log(error)
          toggleToast("Erro ao buscar os portais. ", "error")
        },
      }
    )

    const { data: tags = [] } = useQuery<any[]>(
      ["getTagsAllFilterPlants"],
      async () => {
        const response = await getTagsAll()
        return Array.isArray(response) ? response : response?.data || []
      },
      {
        onError: (error) => {
          console.log(error)
          toggleToast("Erro ao buscar as tags. ", "error")
        },
      }
    )

    const refresh = () => {
      refreshPlants()
    }

    const activeFiltersCount = [
      filterMarks,
      filterPlano,
      filterTag,
      filterOrderByName,
      filterOfflineMoreThan3h,
      filterPerformance.period && filterPerformance.direction ? 'performance' : '',
    ].filter((value) => value !== '').length

    useEffect(() => {
      const start = (pagination.page - 1) * pagination.limit + 1;
      const end = Math.min(pagination.page * pagination.limit, pagination.total);
  
      setQtd({start: start, end: end === 0 ? pagination.limit : end})
      
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [pagination.page]);


    if (loadingSomeAlarmStatus || loadingMyMarks) {
      return (
        <div className={styles.divSpinnerTablePlants}>
          <Loading myClass={`spinner-border ${styles.spinnerTablePlants}`}/>
        </div>
      );
    }

    return (
      <div className={`card ${className} pb-2`}>
        <div
          className={`border-0 ${listLayoutStyles.listCardHeader}`}
          style={{padding: width < 992 ? '1rem 0.75rem 0' : '1.25rem 1.25rem 0'}}
        >
          <div className={toolbarStyles.toolbarWrap} style={{marginBottom: '0.5rem'}}>
            <div className={`${styles.plantsToolbar} ${listLayoutStyles.listToolbarPanel}`}>
              <div className={`${toolbarStyles.searchBox} ${styles.plantsSearch}`}>
                <SearchInputV3
                  className={`form-control form-control-sm ${listLayoutStyles.listSearch}`}
                  placeholder={"Buscar por nome"}
                  setMySearch={setFilterName}
                  setPagination={setPagination}
                  style={{width: '100%'}}
                />
              </div>

              <div className={styles.plantsToolbarActions}>
                <div className="dropdown">
                  <button
                    type="button"
                    className="btn btn-light btn-active-color-primary btn-sm dropdown-toggle position-relative"
                    data-bs-toggle="dropdown"
                    aria-expanded="false"
                    data-bs-auto-close="outside"
                    title='Filtros'
                  >
                    <KTSVG path='/media/icons/duotune/general/gen031.svg' className='svg-icon-3'/>
                    {activeFiltersCount > 0 && (
                      <span className='position-absolute top-0 start-100 translate-middle badge badge-circle badge-primary'>
                        {activeFiltersCount}
                      </span>
                    )}
                  </button>

                  <div className={`dropdown-menu dropdown-menu-end p-4 ${listLayoutStyles.listFilterDropdownMenu} ${toolbarStyles.filterMenu}`}>
                    <label className='form-label fw-bold' style={{marginTop: '0.5rem', marginBottom: '0.5rem'}}>Outros Filtros</label>
                    <div className='separator my-2'></div>

                    <div style={{marginTop: '0.5rem', marginBottom: '1rem', width: '100%'}}>
                        <SelectGlobal
                          itens={marks}
                          buttonAll={true}
                          textSearch={"Buscar portal"}
                          textButtonInit={"Filtrar por PORTAL"}
                          labelKey='name'
                          valueKey='id'
                          typeIcon='img'
                          linkIcon='/media/icons/duotune/abstract/abs023.svg'
                          sizeIconSvg='2'
                          value={filterMarks ? filterMarks : ""}
                          className={styles.selectFilter}
                          setPagination={setPagination}
                          onChange={(value: string) => {
                            setFilterMarks(value)
                          }}
                        />

                        <SelectGlobal
                          itens={[{name: 'PREMIUM'}, {name: 'STARTER'}, {name: 'BASICA'}]}
                          buttonAll={true}
                          textSearch={"Buscar plano"}
                          textButtonInit={"Filtrar por PLANO"}
                          labelKey='name'
                          valueKey='name'
                          typeIcon='svg'
                          linkIcon='/media/icons/duotune/finance/fin002.svg'
                          sizeIconSvg='2'
                          value={filterPlano ? filterPlano : ""}
                          className={`${styles.selectFilter} mt-1`}
                          setPagination={setPagination}
                          onChange={(value: string) => {
                            setFilterPlano(value)
                          }}
                        />

                        <SelectGlobal
                          itens={tags}
                          buttonAll={true}
                          textSearch={"Buscar tag"}
                          textButtonInit={"Filtrar por TAG"}
                          labelKey='name'
                          valueKey='id'
                          typeIcon='tag'
                          colorKey='color'
                          linkIcon='/media/icons/duotune/general/gen025.svg'
                          sizeIconSvg='2'
                          value={filterTag ? filterTag : ""}
                          className={`${styles.selectFilter} mt-1`}
                          setPagination={setPagination}
                          onChange={(value: string) => {
                            setFilterTag(value)
                          }}
                        />

                        <SelectGlobal
                          itens={[
                            {name: 'MAIS RECENTES', value: ''},
                            {name: 'ORDEM ALFABÉTICA', value: 'true'}
                          ]}
                          buttonAll={false}
                          textSearch={"Buscar ordenação"}
                          textButtonInit={"Ordenar por"}
                          labelKey='name'
                          valueKey='value'
                          typeIcon='svg'
                          linkIcon='/media/icons/duotune/arrows/arr072.svg'
                          sizeIconSvg='2'
                          value={filterOrderByName}
                          className={`${styles.selectFilter} mt-1`}
                          setPagination={setPagination}
                          onChange={(value: string) => {
                            setFilterOrderByName(value)
                          }}
                        />

                        <SelectGlobal
                          itens={[
                            {name: 'OFFLINE HÁ MAIS DE 3H', value: 'true'}
                          ]}
                          buttonAll={true}
                          textSearch={"Buscar status offline"}
                          textButtonInit={"Filtrar por OFFLINE"}
                          labelKey='name'
                          valueKey='value'
                          typeIcon='svg'
                          linkIcon='/media/icons/duotune/general/gen013.svg'
                          sizeIconSvg='2'
                          value={filterOfflineMoreThan3h}
                          className={`${styles.selectFilter} mt-1`}
                          setPagination={setPagination}
                          onChange={(value: string) => {
                            setFilterOfflineMoreThan3h(value)
                          }}
                        />

                        <div className='separator my-3'></div>
                        <label className='form-label fw-bold mb-2'>Filtrar por DESEMPENHO</label>

                        <SelectGlobal
                          itens={[
                            {name: '1D', value: '1D'},
                            {name: '15D', value: '15D'},
                            {name: '30D', value: '30D'},
                            {name: '12M', value: '12M'},
                          ]}
                          buttonAll={true}
                          textSearch={"Buscar período"}
                          textButtonInit={"Período"}
                          labelKey='name'
                          valueKey='value'
                          typeIcon='svg'
                          linkIcon='/media/icons/duotune/graphs/gra010.svg'
                          sizeIconSvg='2'
                          value={filterPerformance.period}
                          className={`${styles.selectFilter} mt-1`}
                          setPagination={setPagination}
                          onChange={(value: string) => {
                            setFilterPerformance((prev) => ({ ...prev, period: value }))
                          }}
                        />

                        <SelectGlobal
                          itens={[
                            {name: 'ACIMA DE', value: 'above'},
                            {name: 'ABAIXO DE', value: 'below'},
                          ]}
                          buttonAll={true}
                          textSearch={"Buscar condição"}
                          textButtonInit={"Condição"}
                          labelKey='name'
                          valueKey='value'
                          typeIcon='svg'
                          linkIcon='/media/icons/duotune/arrows/arr091.svg'
                          sizeIconSvg='2'
                          value={filterPerformance.direction}
                          className={`${styles.selectFilter} mt-1`}
                          setPagination={setPagination}
                          onChange={(value: string) => {
                            setFilterPerformance((prev) => ({ ...prev, direction: value }))
                          }}
                        />

                        <div className='mt-2'>
                          <label className='form-label fw-semibold fs-7 mb-1'>Valor (%)</label>
                          <input
                            type='number'
                            min={0}
                            step={0.01}
                            className='form-control form-control-sm form-control-solid'
                            placeholder='100'
                            value={filterPerformance.value}
                            onChange={(e) => {
                              setFilterPerformance((prev) => ({ ...prev, value: e.target.value }))
                              setPagination((prev) => ({ ...prev, page: 1 }))
                            }}
                          />
                        </div>
                    </div>

                    <div className='separator my-2'></div>

                    <div style={{display: 'flex', justifyContent: 'center', alignItems: 'center'}}>
                      <button
                        className='btn btn-color-gray-600 btn-active-color-primary'
                        onClick={() => {
                          setFilterMarks("")
                          setFilterPlano("")
                          setFilterTag("")
                          setFilterOrderByName("")
                          setFilterOfflineMoreThan3h("")
                          setFilterPerformance(DEFAULT_PERFORMANCE_FILTER)
                          setFilterName("")
                          setFilterAlarms(-1)
                          setPagination({...pagination, page: 1})
                        }}>
                        Limpar todos os filtros <KTSVG path='/media/icons/duotune/arrows/arr064.svg' className='svg-icon-5' />
                      </button>
                    </div>
                  </div>
                </div>

                {setIsExpanded && (
                  <button
                    type="button"
                    className={`btn btn-sm btn-icon ${isExpanded ? 'btn-primary' : 'btn-light btn-active-color-primary'}`}
                    onClick={() => setIsExpanded(!isExpanded)}
                    title={isExpanded ? "Recolher" : "Expandir"}
                  >
                    <KTSVG path='/media/icons/duotune/arrows/arr035.svg' className='svg-icon-3' />
                  </button>
                )}

                {user
                  && user.currentUser && user.currentUser.role && user.currentUser.role.slug !== "CLIENTE"
                  && user.currentUser.role.slug !== "ADMIN" &&
                <div className="dropdown">
                  <button
                    type="button"
                    className={`btn btn-sm btn-light-primary dropdown-toggle ${styles.buttonNewPlant}`}
                    data-bs-toggle="dropdown"
                    aria-expanded="false"
                    data-bs-auto-close="outside"
                    title='Nova usina'
                  >
                    <KTSVG path='/media/icons/duotune/arrows/arr075.svg' className='svg-icon-3' />
                    <span className={styles.buttonNewPlantLabel}>Nova USINA</span>
                  </button>

                  <div
                    className="menu menu-sub menu-sub-dropdown menu-column menu-rounded menu-gray-600 menu-state-bg menu-state-primary fw-bold py-4 fs-6 dropdown-menu dropdown-menu-end"
                    style={{width: 'auto', minWidth: '240px', maxWidth: 'calc(100vw - 2rem)'}}
                    data-kt-menu='true'
                  >
                    <div className='menu-item px-5 my-1' >
                      <Link
                        to="/portals"
                        className='menu-link px-5'
                      >
                        <div className='symbol symbol-20px me-5'>
                          <img
                              src={'https://res.cloudinary.com/deq3ehxe3/image/upload/v1735238752/plant2_tuwshh.png'}
                              className=''
                              alt=''
                          />
                        </div>
                        Usina SIMPLES
                      </Link>
                    </div>

                    <div className='menu-item px-5 my-1'>
                      <a
                        onClick={() => {
                          setShowCreateAppModalPlantComposite(true)
                        }}
                        className='menu-link px-5'
                      >
                        <div className='symbol symbol-30px me-5'>
                          <img
                              src={'https://res.cloudinary.com/deq3ehxe3/image/upload/v1763493847/plantComposite_r8bje0.png'}
                              className=''
                              alt=''
                          />
                        </div>

                        Usina COMPOSTA
                      </a>
                    </div>
                  </div>
                </div>}
              </div>
            </div>

            <PlantStatusTabs
              alarmStatus={alarmStatus}
              filterAlarms={filterAlarms}
              onChange={(value) => {
                setFilterAlarms(value)
                setPagination((prev) => ({...prev, page: 1}))
              }}
            />
          </div>
        </div>

        <div className='card-body py-3 pb-2'
          style={isExpanded ? {
            overflow: 'auto', 
            height: 'calc(100vh - 200px)',
          } : width < 1200 ? {
            overflow: 'auto', 
            height: height < 785 ? '30vh'
            : height > 785 && height < 830 ? '32vh' 
            : height >= 830 && height <= 850 ? '35vh' 
            : height > 850 && height <= 930 ? '39vh'
            : '40vh',
          } : {}}
        >
          <div className={`table-responsive ${styles.myTableResponsive}`}>
            {loadingMyPlants ? 
              <div className={styles.divSpinnerTablePlants}>
                <Loading myClass={`spinner-border ${styles.spinnerTablePlants}`}/>
              </div>
            :
              <div className={styles.divTable}>
                {width < 1200 ?
                  <TablePlantsSearchPhone
                    plants={control === false ? plants : mySearch}
                    refresh={refresh}
                  />
                :
                  <TablePlantsSearchComputer
                    plants={control === false ? plants : plants}
                    refresh={refresh}
                  />
                }
              </div> 
            }
          </div>
        </div>

        {width > 1000 &&
          <div className='card-footer px-5 pe-0 pt-1 pb-1'>
            <PaginationTablePlants 
              pagination={pagination}
              setPagination={setPagination}
              qtd={qtd}
            />
          </div>
        }

        {user && user.currentUser && user.currentUser.role && user.currentUser.role.slug !== "ADMIN" && 
          <ModalCreatePlantCompositeTable
            show={showCreateAppModalPlantComposite}
            handleClose={() => {
              setShowCreateAppModalPlantComposite(false)
              refreshPlants()
            }}
          />
        }
      </div>
    )
}

export {TablesPlants}
